export default function PHP_xml_set_character_data_handler() {
  return (
    <div>
      <h1>PHP_xml_set_character_data_handler</h1>
    </div>
  );
}
